/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
import _includes from 'lodash/includes';
import AddressRemovalPopup from './AddressRemovalPopup';
import { hideModal } from '../../../actions/modal';
import { editAddress, setCheckedAddress, setDelivery } from '../../actions/addressBook';
import AddAddress from '../responsive/AddAddress';
import AddAddressNew from '../mobile/AddAddress';
import ReadyToSelfShipPopup from './ReadyToSelfShipPopup';
import { getServiceOrNonServicabilityItems } from '../../../edd/utils/utils.js';
import { getDateRange } from '../../../edd/utils/getDateRange.js';
import { findLowerAndUpperLimit } from '../../../edd/utils/findLowerAndUpperLimit.js';
import { isServerRendering } from '../../../utils/pageInfo.js';
import Icon from '../../../refresh/atoms/Icon';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';
import {
  getPickFromStoreFlag,
  getShowStorePickUpTab,
  getLuxeFlags
} from '../../../Flags/selectors';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import Dialog from '../../../refresh/molecules/Dialog';
import AddAddressDesktop from './AddAddressDesktop';
import luxeScreen from '../../../refresh/constants/luxeScreenType';
import { getGSTFlag } from '../../../refresh/selectors/featureFlagsSelector';
import { changeAddressSelectionOnCart } from '../../../cart/actions/cart';

const style = Object.freeze({
  fontSize: '24px',
  fontWeight: 'bold'
});
function isEDDRequired(url = '') {
  if (isServerRendering()) {
    return url.includes('/shipping') || url.includes('/addresses'); //have to check
    //may be have to check referrer
  } else {
    const { location: { pathname = '' } = {} } = window;
    return pathname.includes('/shipping') || pathname.includes('/addresses');
  }
}
class AddressBox extends React.Component {
  constructor(props) {
    super(props);
    this.label = {
      shipProduct: 'Cancel',
      returnExNotServiciable:
        "We're sorry, AJIO doesn't service your address for Returns/Exchange. Ship your product to our address and we will process your request.",
      readMoreForSelfShip: 'Read How to Self Ship'
    };
    this._callback = this.callback.bind(this);
    this.state = {
      removeFromBagModal: false,
    };
    this.addressBoxRef = React.createRef();
    this.intervalId = null;
  }
  callback(addresses = [], addrFormType, gaEventParams) {
    if (this.props.callback) {
      this.props.callback(addresses, addrFormType, gaEventParams);
    }
  }


  // Handle keyboard navigation and activation
  handleKeyDown = (e) => {
    const current = this.addressBoxRef.current;
    if (!current) return;

    switch (e.key) {
      case "ArrowDown":
      case "ArrowUp": {
        e.preventDefault();
        const options = Array.from(
          current.parentElement.querySelectorAll('[role="option"]')
        );
        const currentIndex = options.indexOf(current);
        let nextIndex;
        if (e.key === "ArrowDown") {
          nextIndex = (currentIndex + 1) % options.length;
        } else {
          nextIndex = (currentIndex - 1 + options.length) % options.length;
        }
        options[nextIndex].focus();

        // Update tabIndex dynamically on options
        options.forEach((opt, i) => {
          opt.tabIndex = i === nextIndex ? 0 : -1;
        });

        break;
      }
      case "Enter":
      case " ": {
        e.preventDefault();
        // onClick();
        e.target?.click()
        break;
      }
      default:
        break;
    }
  };

  // When the option receives focus, update tabIndex on siblings
  handleFocus = () => {
    const current = this.addressBoxRef.current;
    if (!current) return;

    const options = Array.from(
      current.parentElement.querySelectorAll('[role="option"]')
    );
    options.forEach((opt) => (opt.tabIndex = -1));
    current.tabIndex = 0;


    current.querySelector("span.mobaddr-editc")?.setAttribute("tabIndex",0)
  };

  handleBlur = () => {
    const current = this.addressBoxRef.current;
    if (!current) return;
    current.querySelector("span.mobaddr-editc")?.setAttribute("tabIndex",-1)

  }

  getEddDetails = ({
    isCartItemsEDDFetching,
    servicability,
    eddCodEligible,
    dateRange,
    reverseService,
    items,
    cartItem,
    oosItems,
    nsItems
  }) => {
    const { isStoreAddress, luxeFlags = {}, name, newDesignLuxe } = this.props;
    const { isThemeEnable } = luxeFlags;
    const luxe = isThemeEnable === 'ON' && name === 'luxe';

    let eddStatus = '';
    if (!isCartItemsEDDFetching) {
      if (servicability) {
        eddStatus = (
          <div className="est-date">
            {eddCodEligible ? (
              <div
                className={luxe ? 'black semi-bold' : 'green semi-bold'}
                aria-label="Cash on delivery available"
              >
                <strong>Cash on delivery available</strong>
              </div>
            ) : null}
            <p>
              <span aria-label={`Estimate Delivery ${dateRange}`}>
                <span aria-hidden="true">
                  Est Delivery{' '}
                  <span className="semi-bold" aria-label={dateRange}>
                    <strong>{dateRange}</strong>
                  </span>
                </span>
              </span>
            </p>
          </div>
        );
      } else {
        let text = 'Currently, we do not deliver to this location.';
        if (oosItems.length > 0) {
          text = 'Some products are out of stock, please remove to proceed.';
        }
        if (nsItems.length > 0) {
          text = 'Certain products are not deliverable to this location.';
        }
        if (nsItems.length === cartItem.length) {
          text = 'Currently, we do not deliver to this location.';
        }
        eddStatus = (
          <div className={luxe ? 'luxe-not-deliverable-msg red' : 'not-deliverable-msg red'}>
            <strong>{text}</strong>
          </div>
        );
      }
    } else {
      eddStatus = <div className="edd-loader address-page" />;
    }
    return eddStatus;
  };
  getSelectedAddress = ({
    isReferrerShippingPage,
    deliveryAddressSelectedId,
    index,
    id,
    activeIndex,
    isShippingPage,
    showOnlyDefaultAddress,
    isAddressBook
  }) => {
    const { device = '', name, luxeFlags = {} } = this.props;
    const { isThemeEnable } = luxeFlags;
    const luxe = name === 'luxe' && isThemeEnable === 'ON';
    const { selectedAddressId } = this.props;

    if (this.props.forceNoSelection) return null;

    if (isAddressBook) {
      const isSelected = selectedAddressId ? selectedAddressId === id : index === activeIndex;
      if (isSelected) {
        return !luxe ? <div className="mobaddr-selected-addr">Address Selected</div> : '';
      }
    } else if (isReferrerShippingPage) {
      const isSelected = selectedAddressId ? selectedAddressId === id : deliveryAddressSelectedId === id;
      if (isSelected) {
        if (device === 'mobile') {
          return (
            <Icon ariaLabel="address selection" icon="icon-Radio-Button-Selected" styles={style} />
          );
        }
        return (
          <div className="address-selected" aria-label="Selected">
            <span className="ic-Circle-tick"></span>Selected
          </div>
        );
      } else {
        if (device === 'mobile') {
          return <Icon ariaLabel="address selection" icon="icon-Radio-Button" styles={style} />;
        }
        return null;
      }
    } else {
      const isSelected = selectedAddressId ? selectedAddressId === id : activeIndex === index;
      if (isSelected) {
        if (device === 'mobile') {
          return (
            <Icon ariaLabel="address selection" icon="icon-Radio-Button-Selected" styles={style} />
          );
        }
        return (
          <div className="address-selected" aria-label="Selected">
            <span className="ic-Circle-tick"></span>Selected
          </div>
        );
      } else {
        if (device === 'mobile') {
          return <Icon ariaLabel="address selection" icon="icon-Radio-Button" styles={style} />;
        }
        return null;
      }
    }
  };
  isSelectedAddress = ({
    activeIndex,
    index,
    isReferrerShippingPage,
    deliveryAddressSelectedId,
    id
  }) => {
    const { selectedAddressId } = this.props;
    if (this.props.forceNoSelection) return '';
    if (isReferrerShippingPage) {
      const isSelected = selectedAddressId ? selectedAddressId === id : deliveryAddressSelectedId === id;
      if (isSelected) {
        return 'active-address';
      } else {
        return 'inactive-address';
      }
    } else {
      const isSelected = selectedAddressId ? selectedAddressId === id : activeIndex === index;
      if (isSelected) {
        return 'active-address';
      } else {
        return 'inactive-address';
      }
    }
  };
  hideDialog() {
    this.setState({ removeFromBagModal: !this.state.removeFromBagModal });
  }

  handleDeleteBtn(discardDeletion, isShippingPage, luxe, id, address) {
    const firstName = address?.firstName || 'This address';
    return luxe ? (
      !discardDeletion && !isShippingPage ? (
        <span
          className={luxe ? 'mobaddr-icon-mar-luxe' : 'mobaddr-icon-mar'}
          onClick={e => {
            this.setState({ removeFromBagModal: !this.state.removeFromBagModal });
            e.stopPropagation();
          }}
          tabIndex={0}
          role="button"
          aria-label={`${firstName} Delete`}
        >
          Delete
        </span>
      ) : null
    ) : !discardDeletion && !isShippingPage ? (
      <span
        className="mobaddr-icon-mar"
        onClick={e => {
          this.props.setModal({
            name: 'address-delete',
            classes: 'address-delete-modal',
            content: (
              <AddressRemovalPopup
                address={address}
                entryNumber={id}
                deleteAddress={this.props.deleteAddress}
                modalName="address-delete"
                luxeFlag={luxe}
              />
            )
          });
          e.stopPropagation();
        }}
          tabIndex={0}
          role="button"
          aria-label={`${firstName} Delete`}
      >
        Delete
      </span>
    ) : null;
  }

    // this function attaches to the button that open any modal, while the modal is open this function sets an interval to continuosly check whether the modal has been closed, if it is then we move the focus back the element where this handler was attached to. customize the query selector to match your dialog to. Copy and reuse this approach elsewhere
    startModalWatcher = (clickedElement) => {
    // (3) If interval already running, clear it first
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }

    this.intervalId = setInterval(() => {
      // (1) check for the modal div that has style="display: block"
      const visibleModal = document.querySelector(
        'div.modal.fade.in.modal-add-address[style*="display: block"]'
      );

      // If visible modal **does not exist anymore**
      if (!visibleModal) {
        // (2) focus back on the element that was clicked
        if (clickedElement) {
          clickedElement.focus();
        }

        // clear interval
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }, 300); // runs every 300ms — adjust if needed
  };
  render() {
    const {
      address = {},
      isShippingPage = false,
      discardDeletion = false,
      discardEdit = false,
      isPageType = '',
      addressBook = {},
      index,
      pageName = '',
      showOnlyDefaultAddress = false,
      edd,
      cartItem,
      isShippingPageSidebar = false,
      isStoreAddress = false,
      storeName = '',
      storeNodeID = '',
      storeTime = '',
      cart,
      device = '',
      showStoreList,
      pickFromStoreFlag = false,
      showStorePickUpTab = false,
      luxeFlags = {},
      name,
      newDesignLuxe,
      handleGtmEvent,
      refundByCash = false,
      closeAddAddressMsite,
      enableGST = true
    } = this.props;

    const { isThemeEnable } = luxeFlags;
    const { location: { pathname = '', search = '' } = {} } = window || {};
    let luxe = isThemeEnable === 'ON' && name === 'luxe';
    if (pathname === '/my-account/address-book' && device !== 'mobile') luxe = false;

    let { activeIndex = 0, activeIndexStore = -1, showStorePickUpTabForUser = 0 } = addressBook;
    let {
      id = '',
      firstName = '',
      lastName = '',
      line1 = '',
      line2 = '',
      line3 = '',
      landmark = '',
      town = '',
      district = '',
      state = '',
      postalCode = '',
      phone = '',
      codEligible = '',
      exchangeService = '',
      reverseService = '',
      defaultAddress = '',
      deliverySlaType = '',
      shippingAddress = '',
      country = '',
      deliveredAddress = '',
      selectedAddressType = ''
    } = address;

    if (isStoreAddress) {
      firstName = storeName;
    }
    //setting data for set Default address
    // Work or Home icon HTML below :
    //<span className="mobaddr-icon-mar">
    //<span className = "ic-Work ic--icon-right-gutter-space"></span>
    //Work
    //</span>
    // As in App its not there we are not using
    const defaultAddrsSetData = { defaultAddress: true };
    const {
      eddDetails,
      activePincode,
      codEligible: eddCodEligible,
      isCartItemsEDDFetching,
      servicability
    } = edd;
    var items = [];
    let nonServiciableItems = [];
    let dateRange;
    let oosItems = [];
    let nsItems = [];
    if (activePincode && isEDDRequired(this.props.url)) {
      items = getServiceOrNonServicabilityItems(cartItem, eddDetails, activePincode, true) || [];
      nonServiciableItems =
        getServiceOrNonServicabilityItems(cartItem, eddDetails, activePincode, false) || [];
      if (servicability) {
        const { lowerLimit, upperLimit } = findLowerAndUpperLimit(
          items.map(({ eddUpper, eddLower }) => ({ eddUpper, eddLower }))
        );
        dateRange = getDateRange({ eddLower: lowerLimit, eddUpper: upperLimit });
      } else {
        oosItems = nonServiciableItems.filter(item => item.reasonForNotServiceability === 'OOS');
        nsItems = nonServiciableItems.filter(item => item.reasonForNotServiceability === 'NS');
      }
    }
    const { deliveryInfo: { deliveryAddress: { id: deliveryAddressSelectedId } = {} } = {} } =
      this.props.cart || {};
    const isAddressBook = _includes(pathname, '/my-account/address-book');
    const isReferrerShippingPage = isAddressBook && _includes(search, 'shipping');
    let selectedActiveIndex = isStoreAddress ? activeIndexStore : activeIndex;
    let estDom = '';
    if (
      isPageType != 'returnOrderSummary' &&
      pageName !== 'ReturnOrderAddress' &&
      isPageType != 'orderDetails' &&
      ((!isStoreAddress && index === activeIndex) ||
        (isStoreAddress && index === activeIndexStore)) &&
      showOnlyDefaultAddress &&
      isShippingPage
    ) {
      if (isEDDRequired(this.props.url) && device === 'desktop') {
        estDom = (
          <div className="addbotpadd add-top-border edd-details">
            <div className="edd-details-container">
              {this.getEddDetails({
                isCartItemsEDDFetching,
                servicability,
                eddCodEligible,
                dateRange,
                reverseService,
                items,
                cartItem,
                oosItems,
                nsItems
              })}
            </div>
          </div>
        );
      } else {
        estDom = this.getEddDetails({
          isCartItemsEDDFetching,
          servicability,
          eddCodEligible,
          dateRange,
          reverseService,
          items,
          cartItem,
          oosItems,
          nsItems
        });
      }
    }
    let mobileSelected = '';
    if (pickFromStoreFlag && showStorePickUpTab) {
      if (showStorePickUpTabForUser === 0) {
        mobileSelected = '';
      } else {
        mobileSelected = 'mobileSelected';
      }
    }
    if (pickFromStoreFlag && !showStorePickUpTab) {
      mobileSelected = 'mobileSelected';
    }
    // let EditAddressComp = isShippingPage ? AddAddressNew: AddAddress;
    let EditAddressComp = null;
    if (isShippingPage) {
      EditAddressComp = AddAddressNew;
      if (device === 'desktop') {
        EditAddressComp = newDesignLuxe ? AddAddressDesktop : AddAddress;
      }
    } else {
      EditAddressComp = AddAddress;
    }

    let sidebarAddrBox = luxe
      ? 'luxe-shipping-sidebar-address-box'
      : 'shipping-sidebar-address-box';
    let normalSideBar = luxe ? 'luxe-shipping-sidebar-address-box' : '';
    let storeAddress = luxe && isStoreAddress ? 'luxe-store-address-box' : '';

    const { shippingStorePickUp: { screenType = '', screenName = '' } = {} } = luxeScreen;

    return (
      <div
        className={`mobaddr-box  ${!showOnlyDefaultAddress &&
          this.isSelectedAddress({
            activeIndex: selectedActiveIndex,
            index,
            isReferrerShippingPage,
            deliveryAddressSelectedId,
            id
          })} 
            ${isShippingPage || luxe ? 'shipping-address-box' : ''} 
                        
            ${isShippingPageSidebar ? sidebarAddrBox : normalSideBar} 
            ${storeAddress}
            ${device === 'mobile' ? mobileSelected : ''}`}
        onClick={() => {
          if (!showOnlyDefaultAddress) {
            this.props.onAddressSelectStart?.();
            this.props.setCheckedAddress(id, postalCode, this.props.index, true, isStoreAddress, () => {
              closeAddAddressMsite?.();
              if (enableGST && isShippingPage && device !== 'mobile') {
                if (!this.props.disableCartUpdate) {
                  this.props.updateAddressOnCart({ addressId: address?.id, pincode: address?.postalCode });
                  this.props.setDefaultAddress({ ...address, defaultAddress: true });
                }
                this.props.hideModal('address-view');
                this._callback();
              }
            });
            if (isStoreAddress) {
              if (window.ga) {
                window.ga('send', {
                  hitType: 'event',
                  eventCategory: 'buttonTap',
                  eventAction: 'Pick from Store-Shipping',
                  eventLabel: 'Store selected, clicked on Done'
                });
              }
              if (luxe || newDesignLuxe) {
                gtmEventPush({
                  event: 'store_search_select',
                  event_category: 'checkout interactions',
                  event_action: 'find store search select',
                  store_type: name,
                  store_name: storeName,
                  page_type: screenType,
                  page_name: screenName
                });
              } else {
                gtmEventPush({
                  event: 'find_store_search_select',
                  store_name: storeName,
                  category: 'Shipping'
                });
              }
            } else {
              if (isShippingPage) {
                if (luxe) {
                  gtmEventPush({
                    event: 'change_address',
                    event_category: 'checkout interactions',
                    event_action: 'change address',
                    store_type: name,
                    page_type: screenType,
                    page_name: screenName
                  });
                } else {
                  gtmEventPush({
                    event: 'shipping_change_address',
                    page_type: 'Change address'
                  });
                }
              }
            }
          }
          if (isReferrerShippingPage) {
            this.props.setDelivery(id).then(() => {
              window.location = '/shipping';
            });
          }
          // if (pageName === "ReturnOrderAddress") {
          //     this.props.setCheckedAddress(id, postalCode, this.props.index);
          // }
        }}
        onKeyDown={this.handleKeyDown}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        {...((window?.location?.href?.includes("/shipping") || (device != 'mobile' && window?.location?.href?.includes("/cart"))) ? {
          ref:this.addressBoxRef,
          onKeyDown: this.handleKeyDown,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          tabIndex: this.props.disableFocus ? -1 : index == 0 ? 0 : -1
          // tabIndex: index == 0 ? 0 : -1
        } : {})}
        {...(device == "mobile" ? {
          'aria-checked': this.isSelectedAddress({
            activeIndex: selectedActiveIndex,
            index,
            isReferrerShippingPage,
            deliveryAddressSelectedId,
            id
          }) == "active-address"
        } : {})}
        role={device == "mobile" ? 'radio' : 'option'}
        aria-label={`Address: ${(this.isSelectedAddress({activeIndex: selectedActiveIndex,
            index,
            isReferrerShippingPage,
            deliveryAddressSelectedId,
            id}) == 'active-address') ? 'Selected' :`` } ${defaultAddress ? "Default" :''}, ${firstName} ${lastName || ''}, ${selectedAddressType}, ${line1 ? line1 + "," : ''} ${landmark ? landmark + "," : ''} ${district}, ${state}, ${country && country.name ? country.name + "," : ''} ${postalCode ? postalCode + "," : ''} ${phone ? 'Phone ' +phone : ''} . ${(device != 'mobile') ? `Press Enter to select. Press 'Tab' to get more options.` : ``}`}
        // aria-describedby='helper-text-sr'
      >
        {/* {(device != 'mobile') && <div
           id='helper-text-sr'
           style={{
            position: "absolute",
            height: 0,
            width: 0,
          pointerEvents: "none",
            opacity: 0
          }}>Press Enter to select. Press 'Tab' to get more options.</div>} */}
        <div
          className={
            luxe
              ? `luxe-address-info-wrapper ${device === 'mobile' ? 'mobileFont' : ''}`
              : `address-info-wrapper ${device === 'mobile' ? 'mobileFont' : ''}`
          }
          role="presentation"
        >
          {device !== 'mobile' ? (
            <div className="address-info-desk-name" role={isPageType=="orderDetails" && 'heading'} aria-level={isPageType=="orderDetails" && 3}>
              <span
                className="address-book-user-name"
                aria-label={firstName + ' ' + lastName + ' '}
              >
                <strong>{firstName + ' ' + lastName + ' '} </strong>
              </span>
              <span className="address-book-addtype" aria-label={selectedAddressType}>
                {selectedAddressType}
              </span>
            </div>
          ) : (
            ''
          )}

          {!isStoreAddress && device === 'desktop' && (
            <div
              className="default-address-tag tan-color"
              aria-label={defaultAddress ? 'Default' : !isAddressBook ? '' : '\u00A0'}
            >
              <strong>{defaultAddress ? 'Default' : !isAddressBook ? '' : '\u00A0'}</strong>
            </div>
          )}
          {!isStoreAddress && device === 'mobile' && (
            <div role="presentation">
              {
                <div className={!luxe ? 'address-tag-flax-normal' : ''}>
                  {!luxe && selectedAddressType && (
                    <div
                      className="default-address-tag tan-color selectedAddressType"
                    >
                      <strong>{selectedAddressType}</strong>
                    </div>
                  )}
                  {luxe && isShippingPage && selectedAddressType && (
                    <div className="default-address-tag-luxe tan-color selectedAddressType">
                      <strong>{selectedAddressType}</strong>
                    </div>
                  )}
                  {defaultAddress && (
                    <div
                      className={`${
                        !luxe ? 'default-address-tag' : 'default-address-tag-luxe'
                      } tan-color selectedAddressType`}
                      aria-hidden="true"
                    >
                      <strong>{defaultAddress ? 'Default' : !isAddressBook ? '' : '\u00A0'}</strong>
                    </div>
                  )}
                </div>
              }
              {/* {
                        selectedAddressType && <div className="default-address-tag tan-color selectedAddressType">{selectedAddressType}</div>
                    }
                    { defaultAddress && 
                        <div className="default-address-tag tan-color selectedAddressType">
                            {defaultAddress ? "Default" : !isAddressBook ? '' : '\u00A0'}
                        </div>
                    } */}
            </div>
          )}
          {device === 'mobile' && typeof showStoreList === 'function' ? (
            <div className="storeChange">
              <span
                className={luxe ? 'luxe-address-book-user-name' : 'address-book-user-name'}
                role="heading"
                aria-level={3}
              >
                <strong>{firstName + ' ' + lastName}</strong>
              </span>
              <span
                data-test="address-change"
                className={luxe ? 'luxe-storeList' : 'storeList'}
                onClick={showStoreList}
                aria-label="Change"
              >
                Change
              </span>
            </div>
          ) : (
            ''
          )}
          {device === 'mobile' && typeof showStoreList !== 'function' ? (
            <span
              className={luxe ? 'luxe-address-book-user-name' : 'address-book-user-name'}
              role="heading"
              aria-level={3}
              aria-hidden="true"
            >
              <strong>{firstName + ' ' + lastName}</strong>
            </span>
          ) : (
            ''
          )}

          {isShippingPage && isStoreAddress && !luxe && (
            <div className="default-address-tag storeTime">
              <span>
                <strong>{`Store timing ${storeTime}`}</strong>
              </span>
            </div>
          )}
          {luxe ? (
            <div>
              {isStoreAddress && (
                <div>
                  <div className={'luxe-address-mobile'}>
                    {/* <span>{isStoreAddress ? 'Contact ' : 'Phone : '}</span> */}
                    <span className="addFontWeight">{storeName}</span>
                  </div>
                  {isShippingPageSidebar && (
                    <div
                      className={refundByCash ? 'default-address-del' : 'default-address-not-del'}
                    >
                      <span>{state ? state : ''}</span>
                      {state && refundByCash && <span className="pipe">|</span>}
                      {refundByCash ? 'Cash on pickup available' : 'Cash on pickup unavailable'}
                    </div>
                  )}
                </div>
              )}

              <div className="address-info">
                {line1 ? line1 + ', ' : ''}
                {line2 ? line2 + ', ' : ''}
                {landmark ? landmark + ', ' : ''}
                {line3 ? line3 + ', ' : ''}
                {town ? town + ', ' : ''}
                {district && state
                  ? `${district}, ${state}`
                  : district
                  ? `${district}`
                  : state
                  ? state
                  : ''}
                , {country.name}
                {postalCode ? ' - ' + postalCode : ''}
                <div className={luxe ? 'luxe-address-mobile' : 'address-mobile'}>
                  {/* <span>{isStoreAddress ? 'Contact ' : 'Phone : '}</span> */}
                </div>
              </div>
              {isStoreAddress && landmark && (
                <div className={luxe ? 'luxe-address-mobile' : 'address-mobile'}>
                  {/* <span>{isStoreAddress ? 'Contact ' : 'Phone : '}</span> */}
                  <span>Landmark : </span>
                  {landmark}
                </div>
              )}
            </div>
          ) : (
            <div className="address-info" aria-labelledby={`address-info-first-${index} address-info-second-${index} address-info-third-${index} address-info-fifth-${index}`} aria-hidden={device == "mobile" ? "true" : "false"}>
              <div
                className={isAddressBook ? 'address-first' : ''}
                id={`address-info-first-${index}`}
                aria-hidden="true"
              >
                {line1 ? line1 + ', ' : ''}
                {line2 ? line2 + ', ' : ''}
              </div>
              <div
                className="address-second"
                id={`address-info-second-${index}`}
                aria-hidden="true"
              >
                {landmark ? landmark + ', ' : ''}
                {line3 ? line3 + ', ' : ''}
                {town ? town + ', ' : ''}
              </div>
              <div
                className="address-third"
                id={`address-info-third-${index}`}
                aria-hidden="true"
              >
                {/* {district ?  district + ', ' : ''} */}
                {district && state
                  ? `${district}, ${state}`
                  : district
                  ? `${district}`
                  : state
                  ? state
                  : ''}
              </div>
              {/* <div className="address-fourth">
                    {state ? state + ' ': ''}
                </div> */}
              <div className="address-fifth" id={`address-info-fifth-${index}`} aria-hidden="true">
                <span>
                  <strong>{country.name} - </strong>
                </span>
                <span>
                  {device==="mobile"?
                  <span aria-label={postalCode?.toString().split('').map(d => d === '0' ? 'zero' : d).join(' ')}>
                    {postalCode?postalCode:''}
                  </span>:
                  <>
                  <span aria-label={postalCode?.toString().split('').map(d => d === '0' ? 'zero' : d).join(' ')} className="sr-only"></span>
                  <span aria-hidden="true">{postalCode?postalCode:''}</span>
                  </>
                  }
                </span>
              </div>
            </div>
          )}
          {!isStoreAddress && (
            <div 
              className={luxe ? 'luxe-address-mobile' : 'address-mobile'}
              aria-labelledby={`phone-text phone-no-${index}`}
              aria-hidden={device == "mobile" ? "true" : "false"}
            >
              {/* <span>{isStoreAddress ? 'Contact ' : 'Phone : '}</span> */}
              <span id='phone-text' aria-hidden="true">
                <strong>Phone : </strong>
              </span>
              <span
                id={`phone-no-${index}`}
                className="addFontWeight"
                aria-hidden="true"
                aria-label={phone?.split('').join(', ')}
              >
                <strong >{luxe ? phone.slice(0, 5) + ' ' + phone.slice(5) : phone}</strong>
              </span>
            </div>
          )}
          {device === 'mobile' && (
            <Dialog
              showDialog={this.state.removeFromBagModal}
              type="drawer"
              onCancel={() => this.hideDialog()}
              ariaLabel="Remove Address"
            >
              <AddressRemovalPopup
                luxeFlag={luxe}
                address={address}
                entryNumber={id}
                deleteAddress={this.props.deleteAddress}
                onCancel={() => this.hideDialog()}
              ></AddressRemovalPopup>
            </Dialog>
          )}

          {device === 'mobile' && estDom}
          {isPageType != 'returnOrderSummary' &&
            pageName !== 'ReturnOrderAddress' &&
            isPageType != 'orderDetails' &&
            !this.props.retrypayment &&
            !(isShippingPage && showOnlyDefaultAddress) &&
            device === 'mobile' && (
              <div
                className={
                  luxe
                    ? 'edit-remove-button-container luxe-editInMobile editInMobileLuxe'
                    : 'edit-remove-button-container editInMobile'
                }
              >
                {luxe ? (
                  this.handleDeleteBtn(discardDeletion, isShippingPage, luxe, id, address)
                ) : !isStoreAddress && !discardEdit ? (
                  <span
                    className={'mobaddr-editc'}
                    aria-haspopup="dialog"
                    onClick={e => {
                      this.startModalWatcher(e.target)
                      this.props.hideModal('address-view');
                      this.props.setModal({
                        name: 'address-edit',
                        classes: 'modal-add-address',
                        content: (
                          <EditAddressComp
                            address={address}
                            entryNumber={id}
                            modalName="add-address-popup"
                            addrFormType="Edit"
                            isPageType={isPageType}
                            callback={this._callback}
                            device={this.props.device}
                            closeAddAddressMsite={this.props.closeAddAddressMsite}
                            handleGtmEvent={handleGtmEvent}
                          />
                        )
                      });
                      e.stopPropagation();
                    }}
                    tabIndex={0}
                    role="button"
                    aria-label={`Edit ${firstName}'s address`}
                  >
                    Edit
                  </span>
                ) : null}
                {luxe ? (
                  !isStoreAddress && !discardEdit ? (
                    <span
                      className="mobaddr-editc-luxe"
                      onClick={e => {
                        this.props.hideModal('address-view');
                        this.props.setModal({
                          name: 'address-edits-luxe',
                          classes: 'mobaddr-editc-luxe',
                          content: (
                            <EditAddressComp
                              address={address}
                              entryNumber={id}
                              modalName="add-address-popup"
                              addrFormType="Edit"
                              isPageType={isPageType}
                              callback={this._callback}
                              device={this.props.device}
                              closeAddAddressMsite={this.props.closeAddAddressMsite}
                              handleGtmEvent={handleGtmEvent}
                              onCancel={() => this.props.onCancel()}
                            />
                          )
                        });
                        e.stopPropagation();
                      }}
                      tabIndex={0}
                      role="button"
                      aria-label={`Edit ${firstName}'s Address`}
                    >
                      <strong>Edit</strong>
                    </span>
                  ) : null
                ) : (
                  this.handleDeleteBtn(discardDeletion, isShippingPage, luxe, id, address)
                )}
                {!defaultAddress && !isShippingPage && luxe ? (
                  <span
                    className="mobaddr-icon-mars make-default"
                    onClick={e => {
                      let newAdresss = Object.assign({}, address); //creating copy of object
                      newAdresss.defaultAddress = !address.defaultAddress; //updating value
                      this.props.setDefaultAddress(newAdresss);
                      e.stopPropagation();
                      defaultAddress = !defaultAddress;
                      // this.props.setDefaultAddress(newAdresss)
                    }}
                  >
                    Mark default
                  </span>
                ) : (
                  ''
                )}
                {this.getSelectedAddress({
                  isReferrerShippingPage,
                  deliveryAddressSelectedId,
                  index,
                  id,
                  activeIndex: selectedActiveIndex,
                  isShippingPage,
                  showOnlyDefaultAddress,
                  isAddressBook
                })}
              </div>
            )
          // :
          // <div className={luxe ? "edit-remove-button-container luxe-editInMobile" :"edit-remove-button-container editInMobile"}>
          //     {
          //         !discardEdit && !isStoreAddress ? <span className="mobaddr-editc"
          //             onClick={(e) => {
          //                 this.props.hideModal('address-view')
          //                 this.props.setModal({
          //                     name:"address-edit",
          //                     classes: "modal-add-address",
          //                     content: <EditAddressComp
          //                         address={address}
          //                         entryNumber = {id}
          //                         modalName = "add-address-popup"
          //                         addrFormType = "Edit"
          //                         isPageType = {isPageType}
          //                         callback = {this._callback}
          //                         device={this.props.device}
          //                         closeAddAddressMsite={this.props.closeAddAddressMsite}
          //                     />
          //                 })
          //                 e.stopPropagation();
          //             }}>
          //             Edit</span>
          //             :null
          //         }
          //         {
          //             !discardDeletion ?
          //                 <span className="mobaddr-icon-mar"
          //                 onClick={(e) => {
          //                     this.props.setModal({
          //                         name:"address-delete",
          //                         classes: "address-delete-modal",
          //                         content: <AddressRemovalPopup
          //                             address={address}
          //                             entryNumber = {id}
          //                             deleteAddress = {this.props.deleteAddress}
          //                             modalName = "address-delete"
          //                         />
          //                     })
          //                     e.stopPropagation();
          //                 }}>
          //                 {/* <span className = "ic-Remove ic--icon-right-gutter-space"></span>  */}
          //                 Delete</span> : ""
          //         }
          //         {
          //             this.getSelectedAddress({isReferrerShippingPage, deliveryAddressSelectedId,index, id, activeIndex: selectedActiveIndex, isShippingPage, showOnlyDefaultAddress, isAddressBook})
          //         }
          // </div>
          }
        </div>
        {device === 'desktop' && estDom}

        {pageName === 'ReturnOrderAddress' && (
          <div className="avail-section">
            <div className="addbotpadd add-top-border">
              <div className={reverseService ? 'highlight-green' : 'highlight-red'}>
                <span className="ic-return rex-icons-addressbox"></span>Return Pickup{' '}
                {reverseService ? 'Available' : 'Not Available'}
              </div>
              <div className={exchangeService ? 'highlight-green' : 'highlight-red'}>
                <span className="ic-exchange rex-icons-addressbox"></span>Exchange{' '}
                {exchangeService ? 'Available' : 'Not Available'}
              </div>
            </div>
            {!reverseService && !exchangeService && (
              <section className="self-ship-panel">
                <label>Ship your product to us</label>
                <div>{this.label.returnExNotServiciable}</div>
                <p
                  className="read-self-ship"
                  onClick={() => {
                    this.props.setModal({
                      name: 'ready-self-ship-modal',
                      classes: 'ready-self-ship-modal',
                      content: <ReadyToSelfShipPopup modalName="ready-self-ship-modal" />
                    });
                  }}
                >
                  {this.label.readMoreForSelfShip}
                </p>
              </section>
            )}
          </div>
        )}
        {isPageType != 'checkout' &&
          pageName !== 'ReturnOrderAddress' &&
          isPageType != 'returnOrderSummary' &&
          isPageType != 'orderDetails' &&
          !isShippingPage &&
          !showOnlyDefaultAddress && (
            <div>
              {isShippingPage && activeIndex !== index ? (
                <div
                  className="addselecttick addbotpadd addDefBacg add-bottom-border add-top-border"
                  onClick={() => {
                    this.props.setCheckedAddress(id, postalCode, this.props.index, undefined, undefined, closeAddAddressMsite);
                  }}
                >
                  {
                    <span className="addselecttick mobaddr-icon-size">
                      <span
                        className={`ic-Ship ic--icon-right-gutter-space ${
                          activeIndex === index ? 'default-active' : 'default-inactive'
                        }`}
                      ></span>
                      SHIP TO THIS ADDRESS
                    </span>
                  }
                </div>
              ) : null}
            </div>
          )}
        {isPageType != 'returnOrderSummary' &&
          pageName !== 'ReturnOrderAddress' &&
          isPageType != 'orderDetails' &&
          !this.props.retrypayment &&
          !(isShippingPage && showOnlyDefaultAddress) &&
          device !== 'mobile' && (
            <div className="edit-remove-button-container">
              {!discardEdit && !isStoreAddress ? (
                <span
                  className="mobaddr-editc"
                  onClick={e => {
                    e.stopPropagation();
                    this.props.hideModal('address-view');
                    // needed to wrap this into a settimeout so this runs in the next tick of the event loop,if we dont do this and press enter on the edit button, the modal switching happens two quickly and causes focus jumping and click event termination
                    setTimeout(()=>{
                      this.props.setModal({
                      name: 'address-edit',
                      classes: 'modal-add-address',
                      content: (
                        <EditAddressComp
                          address={address}
                          entryNumber={id}
                          modalName="add-address-popup"
                          addrFormType="Edit"
                          isPageType={isPageType}
                          callback={this._callback}
                          device={this.props.device}
                          handleGtmEvent={handleGtmEvent}
                        />
                      )
                    });
                    handleGtmEvent
                      ? handleGtmEvent('edit_address', 'edit address click', 'Edit')
                      : null;
                    // e.stopPropagation();
                    },0)
                  }}
                {...(window?.location?.href?.includes("/shipping") || (device != 'mobile' && window?.location?.href?.includes("/cart"))) ? {} : {
                  onKeyDown: (e) => {
                    if (e.key == "Enter" || e.key == " " || e.code == "Space") {
                      e.target.click();

                    }
                  }
                }}

                  tabIndex={(window?.location?.href?.includes("/shipping") || (device != 'mobile' && window?.location?.href?.includes("/cart"))) ? -1 : 0}
                  role="button"
                  aria-label={`Edit ${firstName}'s Address`}
                  // onKeyDown={(e)=>{
                  //   console.log("pressed")
                  //   const key = e.key;

                  //   if(key == "Enter" || key == "Space" || key == " "){
                  //     e.preventDefault();
                  //     e.stopPropagation();
                  //     setTimeout(() => {
                  //     e.target.click(); 
                  //   }, 0); 
                  //   }
                  // }}
                >
                  <span
                    className="ic-Edit ic--icon-right-gutter-space"
                    role="presentation"
                    aria-hidden={true}
                  />
                Edit
                </span>
              ) : null}
              {!discardDeletion ? (
                <span
                  className="mobaddr-icon-mar"
                  data-test="delete-click"
                  onClick={e => {
                    this.props.setModal({
                      name: 'address-delete',
                      classes: 'address-delete-modal',
                      content: (
                        <AddressRemovalPopup
                          address={address}
                          entryNumber={id}
                          deleteAddress={this.props.deleteAddress}
                          modalName="address-delete"
                        />
                      )
                    });
                    e.stopPropagation();
                  }}
                aria-label={`${firstName} Delete`}
                tabIndex={0}
                role="button"
                >
                  Delete
                </span>
              ) : (
                ''
              )}
              {this.getSelectedAddress({
                isReferrerShippingPage,
                deliveryAddressSelectedId,
                index,
                id,
                activeIndex: selectedActiveIndex,
                isShippingPage,
                showOnlyDefaultAddress,
                isAddressBook
              })}
            </div>
          )}
      </div>
    );
  }
}
const mapStatetoProps = state => {
  const { addressBook = {}, edd, cartItem, cart, flags = {} } = state;
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);

  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';

  return {
    addressBook,
    edd,
    cartItem,
    cart,
    pickFromStoreFlag: getPickFromStoreFlag(flags),
    showStorePickUpTab: getShowStorePickUpTab(flags),
    luxeFlags: getLuxeFlags(flags),
    name: getCurrentStore(state),
    newDesignLuxe,
    enableGST: getGSTFlag(state)
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    hideModal: name => {
      dispatch(hideModal(name));
    },
    setDefaultAddress: addressObj => {
      dispatch(editAddress(addressObj));
    },
    setCheckedAddress: (id, postalCode, index, edd, isStoreAddress, callback) => {
      dispatch(setCheckedAddress(id, postalCode, index, edd, isStoreAddress, callback));
    },
    setDelivery: id => setDelivery(id, dispatch),
    updateAddressOnCart: (obj) => {
      dispatch(changeAddressSelectionOnCart(obj));
    }  
  };
};
export default AddressBox = connect(mapStatetoProps, mapDispatchToProps)(AddressBox);
